/* src/app/json-editor-module/json-forms-new-popup/json-forms-new/json-forms-new.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 20px;
}
.form-json-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.buttons-action {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
}
.link {
  text-decoration: underline;
  font-weight: 500;
  color: #3b80f9;
  cursor: pointer;
  font-size: 120%;
  padding: 0;
  margin: 0;
}
.orange-button {
  background-color: orange;
  border-color: orange;
  color: white;
}
.orange-button:hover,
.orange-button:focus {
  background-color: darkorange;
  border-color: darkorange;
}
/*# sourceMappingURL=json-forms-new.component.css.map */
